/**
 * Einfache, sprachunabhängige Suche für das Hilfe-Center.
 * Groß-/Kleinschreibung und Akzente werden ignoriert; jedes Suchwort muss irgendwo vorkommen,
 * Treffer in Titel bzw. Frage zählen mehr als im Text.
 */
export const normalizeText = (s) => s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\[(?:\/)?(?:ui|watch|set|b|code|link)(?:=[^\]]*)?\]/g, '');
export function scoreMatch(query, item) {
    const terms = normalizeText(query).split(/\s+/).filter(Boolean);
    if (!terms.length)
        return 0;
    const title = normalizeText(item.title);
    const tags = (item.tags || []).map(normalizeText);
    const body = normalizeText(item.body || '');
    let score = 0;
    for (const term of terms) {
        let s = 0;
        if (title.includes(term))
            s = Math.max(s, 3);
        if (tags.some((tag) => tag.includes(term) || (term.length > 2 && term.includes(tag))))
            s = Math.max(s, 2);
        if (body.includes(term))
            s = Math.max(s, 1);
        if (s === 0)
            return 0; // jedes Wort muss passen
        score += s;
    }
    return score;
}
export function searchItems(query, items, toSearchable, max = 20) {
    return items
        .map((item) => ({ item, score: scoreMatch(query, toSearchable(item)) }))
        .filter((r) => r.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, max)
        .map((r) => r.item);
}
